import React from "react";
import { AlertTriangle, Check } from 'lucide-react';
import { AlertVariant } from "../../types-interfaces/types";
import { AlertBodyStyle, AlertMainStyle, AlertRadiusColorStyle } from "../styles/AlertStyle";
import { Button } from "..";
import { CloseButtonStyle } from "../styles/ButtonStyle";

interface AlertProps extends React.HTMLAttributes<HTMLElement>{    
  text?: string | undefined
  type?: AlertVariant
  alt?: string | undefined
  onClose?: React.MouseEventHandler<HTMLButtonElement> | undefined
}

interface AlertState {
  color: string | undefined
}

class Alert extends React.Component<AlertProps, AlertState> {

  state = { color: "#C00000"};

  componentDidMount(): void {
    let newColor = undefined;
    switch(this.props.type){
      case "error":
        newColor = "#C00000";
        break;
      case "warning":
        newColor = "#F76800";
        break;
      case "success":
        newColor = "#00A29B";
        break;
      case undefined:
        newColor = undefined;
        break;      
    }

      this.setState({ color: newColor})
  }

  componentDidUpdate(prevProps: Readonly<AlertProps>, prevState: Readonly<AlertState>, snapshot?: any): void {
    if (prevProps.type !== this.props.type){
      let newColor = undefined;
      switch(this.props.type){
        case "error":
          newColor = "#C00000";
          break;
        case "warning":
          newColor = "#F76800";
          break;
        case "success":
          newColor = "#00A29B";
          break;
        case undefined:
          newColor = undefined;
          break;      
      }
      this.setState({ color: newColor})
    }
      
  }

  render() {
    if (!this.props.hidden)
    return (
      <div
        style={AlertMainStyle}
      > 
        <div
          style={{
            ...AlertRadiusColorStyle,
            background: this.state.color
          }}
        >
        </div>
        <div
          style={AlertBodyStyle}
        >
          {this.props.type === "success"? <Check/>: <AlertTriangle/>}
          {this.props.text}
          {this.props.children}
          <Button            
            text="x"
            onClick={this.props.onClose}
            style={CloseButtonStyle}
          />
        </div>
      </div>
    );
  }
}

export default Alert;